// i18next Language Keys
export const EN = "en";
export const ESP = "es";
export const FR = "fr";

export const UNAUTHORIZED_ERROR_CODE = "UNAUTHORIZED";
